// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__K24fq","large":"styles_large__Z5Tgd"};